import { gql } from '@apollo/client';

export const UNLINK_PATIENT_FROM_PHARMACY = gql`
  mutation unlinkPatientFromPharmacy($data: UnlinkPharmacyInput!) {
    unlinkPatientFromPharmacy(data: $data)
  }
`;
